import { NgModule } from "@angular/core";
import {
  InvoiceClientProvider,
  API_BASE_URL,
  AMClientProvider,
  AddressesClientProvider,
  AdministrationClientProvider,
  AnlageGroupsClientProvider,
  AnlagenClientProvider,
  BelegeClientProvider,
  BelsoftUsersClientProvider,
  ContractAddressesClientProvider,
  ContractOffersClientProvider,
  ContractsClientProvider,
  ContractsV2ClientProvider,
  ContractObjectsV2ClientProvider,
  EventsClientProvider,
  FacilityMonitoringClientProvider,
  FormularVorlagenClientProvider,
  FormulareClientProvider,
  InfoportalDokumenteClientProvider,
  InfoportalTagsClientProvider,
  InfoportalFoldersClientProvider,
  InternalServicesClientProvider,
  KundenClientProvider,
  LicensesClientProvider,
  LiquidWidgetsClientProvider,
  MailClientProvider,
  MandantClientProvider,
  NotesClientProvider,
  NotificationsClientProvider,
  PlanungReportsClientProvider,
  ResourcesClientProvider,
  RoleClientProvider,
  TaskCategoriesClientProvider,
  TaskStatusMetaClientProvider,
  TasksClientProvider,
  TextblocksClientProvider,
  TimeRecordAccountsClientProvider,
  TimeRecordsClientProvider,
  UserManagementClientProvider,
  UsersClientProvider,
  WartungsHistoryClientProvider,
  WawiMasterDataClientProvider,
  AnlageDynamicFieldsClientProvider,
  FacilityInformationPageClientProvider,
  UserAccessTokensClientProvider,
} from "./web-api";

@NgModule({
  providers: [
    {
      provide: API_BASE_URL,
      useFactory: () => {
        if (document.location.href.includes("/test")) {
          return "/test";
        }
        return "";
      },
    },
    InvoiceClientProvider,
    AMClientProvider,
    AddressesClientProvider,
    AdministrationClientProvider,
    AnlageGroupsClientProvider,
    AnlagenClientProvider,
    BelegeClientProvider,
    BelsoftUsersClientProvider,
    ContractAddressesClientProvider,
    ContractOffersClientProvider,
    ContractsClientProvider,
    ContractsV2ClientProvider,
    ContractObjectsV2ClientProvider,
    EventsClientProvider,
    FacilityInformationPageClientProvider,
    FacilityMonitoringClientProvider,
    FormularVorlagenClientProvider,
    FormulareClientProvider,
    InfoportalDokumenteClientProvider,
    InfoportalTagsClientProvider,
    InfoportalFoldersClientProvider,
    InternalServicesClientProvider,
    KundenClientProvider,
    LicensesClientProvider,
    LiquidWidgetsClientProvider,
    MailClientProvider,
    MandantClientProvider,
    NotesClientProvider,
    NotificationsClientProvider,
    PlanungReportsClientProvider,
    ResourcesClientProvider,
    RoleClientProvider,
    TaskCategoriesClientProvider,
    TaskStatusMetaClientProvider,
    TasksClientProvider,
    TextblocksClientProvider,
    TimeRecordAccountsClientProvider,
    TimeRecordsClientProvider,
    UserManagementClientProvider,
    UsersClientProvider,
    UserAccessTokensClientProvider,
    WartungsHistoryClientProvider,
    WawiMasterDataClientProvider,
    AnlageDynamicFieldsClientProvider,
  ],
})
export class WebApiModule {}
